import { render, staticRenderFns } from "./ControlVersion.vue?vue&type=template&id=308f1852&"
import script from "./ControlVersion.vue?vue&type=script&lang=js&"
export * from "./ControlVersion.vue?vue&type=script&lang=js&"
import style0 from "./ControlVersion.vue?vue&type=style&index=0&id=308f1852&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports